<template>
    <div class="category-page-list-item"><ProductCard :product="product" /></div>
</template>
<script>
import ProductCard from "../../ProductCard.vue";
export default { components: { ProductCard }, props: ["product"] };
</script>
